export interface HeroSlide {
  id: string;
  label: string;
  title: string;
  description: string;
  image: string;
  link: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: "h1",
    label: "第一季 · 第 1 集",
    title: "走进姜家大门",
    description:
      "一场低调的婚礼，让身份神秘的尹瑟琪正式走入姜家。看似平静的宅子里，各方势力已经悄然就位。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20an%20elegant%20woman%20in%20a%20navy%20dress%20walking%20into%20a%20grand%20dim%20mansion%20hall%20with%20tall%20windows%2C%20guests%20in%20silhouette%2C%20moody%20low-key%20lighting%2C%20deep%20blue%20and%20gold%20tones%2C%20atmospheric%20film%20grain&width=1920&height=1080&seq=hero-01&orientation=landscape",
    link: "/detail/episode/e1",
  },
  {
    id: "h2",
    label: "第一季 · 第 4 集",
    title: "雨夜的一把伞",
    description:
      "一场暴雨中，志勋的车在郊外抛锚，恰好路过的瑟琪选择停下。这个夜晚，改变了两人之间的一切。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20two%20people%20sheltering%20under%20a%20rain-soaked%20overpass%20at%20night%2C%20neon%20reflections%20on%20wet%20asphalt%2C%20cool%20blue%20tones%20with%20warm%20streetlight%2C%20moody%20atmospheric%20film%20grain&width=1920&height=1080&seq=hero-02&orientation=landscape",
    link: "/detail/episode/e4",
  },
  {
    id: "h3",
    label: "第二季 · 第 12 集",
    title: "站在她这一边",
    description:
      "面对婉婷的连环发难，志勋第一次在家族会议上公开站在瑟琪身旁，两人关系迎来重要转折。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20man%20and%20woman%20standing%20shoulder%20to%20shoulder%20in%20a%20tense%20meeting%20room%20facing%20a%20hostile%20crowd%2C%20backlit%20dramatic%20lighting%2C%20deep%20blue%20tones%2C%20atmospheric%20film%20grain&width=1920&height=1080&seq=hero-03&orientation=landscape",
    link: "/detail/episode/e12",
  },
  {
    id: "h4",
    label: "第三季 · 大结局",
    title: "雪夜之后是晨光",
    description:
      "恩怨落幕，姜家迎来新的时代。瑟琪站在大门前，第一次觉得自己真正属于这里。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20sunlit%20mansion%20gate%20opening%20at%20dawn%20with%20light%20falling%20snow%2C%20two%20figures%20walking%20through%20together%2C%20warm%20hopeful%20morning%20light%2C%20golden%20and%20soft%20blue%20tones%2C%20atmospheric%20film%20grain&width=1920&height=1080&seq=hero-04&orientation=landscape",
    link: "/detail/episode/e18",
  },
];